import React, { useMemo } from "react";
import { getChainById, stringToBlobUrl } from "common";
import { ProgressStatus } from "../../api/types";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useCheckoutStore } from "../../../checkoutStore";
import { Button } from "common/src/styles";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MRCProgressModalBody(_ref) {
  var _checkoutStore$curren;
  let {
    tryAgainFn,
    setIsOpen
  } = _ref;
  const checkoutStore = useCheckoutStore();
  const chainIdsBeingCheckedOut = checkoutStore.chainsToCheckout;
  const chainId = (_checkoutStore$curren = checkoutStore.currentChainBeingCheckedOut) !== null && _checkoutStore$curren !== void 0 ? _checkoutStore$curren : chainIdsBeingCheckedOut[0];
  const chain = getChainById(chainId);
  const {
    voteStatus,
    permitStatus,
    chainSwitchStatus
  } = useCheckoutStore();
  const progressSteps = useMemo(() => {
    const stepsWithChainSwitch = [{
      name: "Switch Network",
      description: `Switch network to ${chain.prettyName}`,
      status: chainSwitchStatus[chainId]
    }, {
      name: "Permit",
      description: "Approve checkout contract",
      status: chainSwitchStatus[chainId] !== ProgressStatus.IS_SUCCESS ? ProgressStatus.NOT_STARTED : permitStatus[chainId]
    }, {
      name: "Submit",
      description: "Finalize your contribution",
      status: permitStatus[chainId] !== ProgressStatus.IS_SUCCESS ? ProgressStatus.NOT_STARTED : voteStatus[chainId]
    }];
    const stepsWithoutChainSwitch = [{
      name: "Permit",
      description: "Permit checkout contract",
      status: permitStatus[chainId]
    }, {
      name: "Submit",
      description: "Finalize your contribution",
      status: voteStatus[chainId]
    }];
    return chainSwitchStatus[chainId] !== ProgressStatus.NOT_STARTED ? stepsWithChainSwitch : stepsWithoutChainSwitch;
  }, [chainId, chainSwitchStatus, permitStatus, voteStatus, chain.prettyName]);
  return /*#__PURE__*/_jsxs("div", {
    className: "sm:w-fit md:w-[400px]",
    children: [chainIdsBeingCheckedOut.length > 1 && /*#__PURE__*/_jsx("div", {
      className: "flex py-2 justify-between",
      children: chainIdsBeingCheckedOut.map((chainId, idx) => {
        const notStarted = chainSwitchStatus[chainId] === ProgressStatus.NOT_STARTED && voteStatus[chainId] === ProgressStatus.NOT_STARTED && permitStatus[chainId] === ProgressStatus.NOT_STARTED;
        const inProgress = chainSwitchStatus[chainId] === ProgressStatus.IN_PROGRESS || voteStatus[chainId] === ProgressStatus.IN_PROGRESS || permitStatus[chainId] === ProgressStatus.IN_PROGRESS || chainSwitchStatus[chainId] === ProgressStatus.IS_ERROR || voteStatus[chainId] === ProgressStatus.IS_ERROR || permitStatus[chainId] === ProgressStatus.IS_ERROR;
        const isSuccess = checkoutStore.voteStatus[chainId] === ProgressStatus.IS_SUCCESS;
        console.log(chainId, "chainswitchstatus", checkoutStore.chainSwitchStatus[chainId]);
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [inProgress && /*#__PURE__*/_jsx(MRCModalChainStep, {
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-blue-500 rounded-full",
              children: /*#__PURE__*/_jsx("span", {
                className: "h-2.5 w-2.5 bg-blue-500 rounded-full animate-pulse-scale"
              })
            }),
            line: /*#__PURE__*/_jsx("div", {
              className: "flex-grow h-0.5 bg-grey-100"
            }),
            isLastStep: idx === chainIdsBeingCheckedOut.length - 1,
            chainCount: chainIdsBeingCheckedOut.length
          }, chainId), isSuccess && /*#__PURE__*/_jsx(MRCModalChainStep, {
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-8 h-8 flex items-center justify-center bg-blue-500 rounded-full",
              children: /*#__PURE__*/_jsx(CheckIcon, {
                className: "w-5 h-5 text-white",
                "aria-hidden": "true"
              })
            }),
            line: /*#__PURE__*/_jsx("div", {
              className: "flex-grow h-0.5 bg-blue-500"
            }),
            isLastStep: idx === chainIdsBeingCheckedOut.length - 1,
            chainCount: chainIdsBeingCheckedOut.length
          }, chainId), notStarted && /*#__PURE__*/_jsx(MRCModalChainStep, {
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 rounded-full border-grey-300"
            }),
            line: /*#__PURE__*/_jsx("div", {
              className: "flex-grow h-0.5 bg-grey-100"
            }),
            isLastStep: idx === chainIdsBeingCheckedOut.length - 1,
            chainCount: chainIdsBeingCheckedOut.length
          }, chainId)]
        });
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "px-2 py-2 font-bold",
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("img", {
          className: "inline mr-1 w-5 h-5",
          alt: chain.prettyName,
          src: stringToBlobUrl(chain.icon)
        }), chainIdsBeingCheckedOut.length > 1 ? /*#__PURE__*/_jsxs("span", {
          className: "font-bold text-[16px]",
          children: ["Step ", chainIdsBeingCheckedOut.indexOf(Number(chainId)) + 1, ": Checkout ", chain.prettyName, " donations"]
        }) : /*#__PURE__*/_jsxs("span", {
          className: "font-bold text-[16px]",
          children: ["Checkout ", chain.prettyName, " donations"]
        })]
      })
    }), /*#__PURE__*/_jsx("nav", {
      "aria-label": "Progress",
      className: "ml-6 mt-2 mb-2",
      children: /*#__PURE__*/_jsx("ol", {
        className: "overflow-hidden",
        children: progressSteps.map((step, stepIdx) => /*#__PURE__*/_jsx("li", {
          className: `relative ${stepIdx !== progressSteps.length - 1 && "pb-4"}`,
          children: step.status === ProgressStatus.IS_SUCCESS ? /*#__PURE__*/_jsx(MRCModalStep, {
            step: step,
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-6 h-6 flex items-center justify-center bg-blue-500 rounded-full",
              "data-testid": `${step.name}-complete-icon`,
              children: /*#__PURE__*/_jsx(CheckIcon, {
                className: "w-5 h-5 text-white",
                "aria-hidden": "true"
              })
            }),
            nameColor: "text-grey-500",
            descriptionColor: "text-grey-500"
          }) : step.status === ProgressStatus.IN_PROGRESS ? /*#__PURE__*/_jsx(MRCModalStep, {
            step: step,
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-6 h-6 flex items-center justify-center bg-white border-2 border-blue-500 rounded-full font-sans text-sm font-medium",
              children: /*#__PURE__*/_jsx("span", {
                className: "h-2.5 w-2.5 bg-blue-500 rounded-full animate-pulse-scale",
                "data-testid": `${step.name}-current-icon`
              })
            }),
            nameColor: "text-black"
          }) : step.status === ProgressStatus.IS_ERROR ? /*#__PURE__*/_jsx(MRCModalStep, {
            step: step,
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-6 h-6 flex items-center justify-center border-2 bg-white border-pink-500 rounded-full",
              children: /*#__PURE__*/_jsx(XMarkIcon, {
                className: "w-5 h-5 text-pink-500",
                "data-testid": `${step.name}-error-icon`
              })
            }),
            nameColor: "text-grey-500"
          }) : step.status === ProgressStatus.NOT_STARTED ? /*#__PURE__*/_jsx(MRCModalStep, {
            step: step,
            icon: /*#__PURE__*/_jsx("span", {
              className: "relative z-10 w-6 h-6 flex items-center justify-center bg-white border-2 rounded-full border-black",
              "data-testid": `${step.name}-upcoming-icon`
            }),
            nameColor: "text-black"
          }) : /*#__PURE__*/_jsx(_Fragment, {})
        }, stepIdx))
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-start flex-col",
        children: [permitStatus[chainId] === ProgressStatus.IS_ERROR && /*#__PURE__*/_jsx("p", {
          className: "text-xs text-grey-400 mt-2 ml-2",
          children: "Transaction rejected or signature denied. Please double check your permissions and try again."
        }), voteStatus[chainId] === ProgressStatus.IS_ERROR && /*#__PURE__*/_jsx("p", {
          className: "text-xs text-grey-400 mt-2 ml-2",
          children: "Transaction failed. Please double check your wallet and try again. If the problem persists, please contact support for assistance."
        })]
      }), (permitStatus[chainId] === ProgressStatus.IS_ERROR || voteStatus[chainId] === ProgressStatus.IS_ERROR) && /*#__PURE__*/_jsxs("div", {
        className: "flex justify-end mt-4 mr-2",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "button",
          $variant: "outline",
          onClick: () => {
            setIsOpen(false);
          },
          className: "inline-flex justify-center px-4 py-2 text-sm",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          $variant: "solid",
          onClick: () => {
            tryAgainFn();
          },
          className: "inline-flex justify-center px-4 py-2 text-sm ml-2",
          children: "Try Again"
        })]
      })]
    })]
  });
}
function MRCModalStep(props) {
  var _props$descriptionCol;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex items-start group",
      "aria-current": !!props.isAriaCurrent,
      children: [/*#__PURE__*/_jsx("span", {
        className: "h-9 flex items-center",
        "aria-hidden": !!props.isAriaHidden,
        children: props.icon
      }), /*#__PURE__*/_jsx("span", {
        className: "ml-2 w-full flex flex-col",
        children: /*#__PURE__*/_jsx("span", {
          className: `flex justify-start text-sm mt-2 font-normal font-sans ${(_props$descriptionCol = props.descriptionColor) !== null && _props$descriptionCol !== void 0 ? _props$descriptionCol : "text-grey-400"}`,
          children: props.step.description
        })
      })]
    })
  });
}
function MRCModalChainStep(props) {
  let widthClass = "";
  if (props.chainCount) {
    switch (props.chainCount) {
      case 2:
        widthClass = "w-full";
        break;
      case 3:
        widthClass = "w-1/2";
        break;
      case 4:
        widthClass = "w-1/3";
        break;
      default:
        widthClass = "w-full";
        break;
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    className: `flex items-center ${props.isLastStep ? "" : widthClass}`,
    children: [/*#__PURE__*/_jsx("span", {
      className: "h-9 flex items-center",
      "aria-hidden": !!props.isAriaHidden,
      children: props.icon
    }), !props.isLastStep && props.line]
  });
}